import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { ActivatedRoute, Router } from '@angular/router';

import { TaskDetailsComponent, TaskDialogData } from '../common/task-details.component';
import { getAllPathParams } from '@workspaces/utils/get-all-path-params';

@Component({
  selector: 'app-task-details-page-route',
  templateUrl: './task-details-page-route.component.html',
  styleUrls: ['./task-details-page-route.component.scss', '../../../global-workspace-styles.scss'],
  standalone: true,
  imports: [TaskDetailsComponent]
})
export class TaskDetailsPageRouteComponent implements OnInit, OnDestroy {
  private readonly sub = new Subscription();
  private currentRouteParams: Record<string, string> = {};
  public data!: TaskDialogData;
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.currentRouteParams = getAllPathParams(this.route.snapshot);

    if (!this.currentRouteParams['taskId'] || !this.currentRouteParams['workspaceId']) {
      return;
    }
    this.data = {
      workspaceId: this.currentRouteParams['workspaceId'],
      taskId: this.currentRouteParams['taskId']
    };
  }
  close() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
